<?xml version="1.0" encoding="UTF-8"?>
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<!-- Creator: CorelDRAW 2020 (64-Bit) -->
<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" version="1.1" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
viewBox="0 0 3598.32 3598.32"
 xmlns:xlink="http://www.w3.org/1999/xlink"
 xmlns:xodm="http://www.corel.com/coreldraw/odm/2003">
 <defs>
  <style type="text/css">
   <![CDATA[
    .fil0 {fill:black;fill-rule:nonzero}
   ]]>
  </style>
 </defs>
 <g id="Layer_x0020_1">
  <metadata id="CorelCorpID_0Corel-Layer"/>
  <g>
   <path class="fil0" d="M2280.25 2119.86c-428.18,0 -1282.85,213.27 -1282.85,641.39l0 320.73 2565.64 0 0 -320.73c0,-428.12 -854.67,-641.39 -1282.79,-641.39l0 0zm-1443.21 -641.46l0 -481.03 -320.73 0 0 481.03 -481.03 0 0 320.73 481.03 0 0 481.09 320.73 0 0 -481.09 481.03 0 0 -320.73 -481.03 0zm1443.21 320.73c354.18,0 641.39,-287.21 641.39,-641.39 0,-354.18 -287.21,-641.4 -641.39,-641.4 -354.18,0 -641.33,287.22 -641.33,641.4 0,354.18 287.15,641.39 641.33,641.39z"/>
  </g>
 </g>
</svg>
